import React from "react";
import { Box } from "@mui/material";
import CompanyLogoSvg from "../../../pages/advertisement/CompanyLogoSvg";
import AppIconPage from "./AppIconPage";
import WordWheelWordLinkMark from "./WordWheelWordLinkMark";

/** Word Wheel Quest app icon #3 — company logo + linked W-O-R-D. */
export default function AppIcon3Page() {
    return (
        <AppIconPage
            fileName="word-wheel-quest-app-icon-3-512x512.png"
            label="App icon #3"
            screenshotFrame="word-wheel-app-icon-3"
            captureBackground="#FCFCFD"
        >
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    "& > svg": { width: "100%", height: "100%", display: "block" },
                }}
            >
                <CompanyLogoSvg idPrefix="wwIcon3Logo" />
            </Box>
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    pointerEvents: "none",
                    "& > svg": { width: "100%", height: "100%", display: "block" },
                }}
            >
                <WordWheelWordLinkMark idPrefix="wwIcon3Word" />
            </Box>
        </AppIconPage>
    );
}
